import React from 'react';
import {Platform} from 'react-native';

import ConnectedAEMFooter from 'containers/aem/ConnectedAEMFooter';

//
// --- Footer Component ---

const EmpireFooter: React.FunctionComponent = () => {
  return Platform.OS === 'web' ? (
    <>
      <ConnectedAEMFooter />
    </>
  ) : null;
};

export default EmpireFooter;
